<template>
  <div class="preview-overlay">
    <div class="box">
      <h1>Chargement de la preview...</h1>
    </div>
  </div>
</template>

<script>
import services from '~/services'

export default {
  name: 'PreviewActivate',
  mounted() {
    const query = this.$route.query
    if (query['sanity-preview-perspective']) {
      services.sanityService.activatePreview(
        query['sanity-preview-perspective'],
        query['sanity-preview-secret']
      )
    }

    if (query['sanity-preview-pathname']) {
      this.$router.push({ path: query['sanity-preview-pathname'] })
    } else {
      this.$router.push({ path: '/' })
    }
  },
}
</script>

<style scoped>
.preview-overlay {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: var(--tertiary-color);
  font-size: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9000;
}
</style>
